import { useTranslator } from "components/Translator"

export const BoatDate = ({ boat }) => {
  const translator = useTranslator()

  if (!boat.createdAt) {
    return null
  }

  const date = new Date(boat.createdAt).toLocaleString(translator.locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  })

  return (
    <time
      aria-label={translator.trans("BoatDate.ariaLabel", null, "components")}
      dateTime={boat.createdAt}
    >
      {date}
    </time>
  )
}
